module.exports = __webpack_public_path__ + "img/famous_p6.4729773b.jpg";